import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import {Grid, Hidden, Typography} from "@material-ui/core";
import Header from "../../components/Header";
import Footer from "../../components/Footer/FooterLoggedIn";
import DinerBanner from '../../components/Banner/DinerBanner';
import Portfolio from "../Chef/Portfolio";
import { client } from "../../config/apollo";
import { FEATURED_CHEFS } from "../../graphql/queries/chef";
import { FEATURED_DISHES } from "../../graphql/queries/dishes";
import FeaturedChefs from "../../components/Chefs/FeaturedChefs";
import FeaturedDishes from "../../components/Dishes/FeaturedDishes";
import FeaturedPosts from "../../components/Posts/FeaturedPosts";
import style from "../../components/Header/style";
import {logoutUser, setInitHomeList} from "../../redux/auth";
import {getUser} from "../../redux/user";
import { setFeaturedChefs, setFeaturedDishes } from "../../redux/chefs";


// class Home extends Component {
const Home = React.memo((props) => {
  const [searchType, setSearchType] = useState(null);
  const [placeholder, setPlaceholder] = useState('Search chefs');
  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    props.dispatch(getUser(props.userId));

    client
        .query({
          query: FEATURED_DISHES,
          variables: {
            dishCount: 6
          }
        })
        .then(resp => {
          if (resp.data) {
            if (resp.data.featuredDishes) {
              props.dispatch(setFeaturedDishes(resp.data.featuredDishes));
            }
          }
        })
        .catch(err => {
          console.error("Featured dishes: ", err);
        });

    client
        .query({
          query: FEATURED_CHEFS,
          variables: {
            chefCount: 8
          }
        })
        .then(resp => {
          if (resp.data) {
            if (resp.data.featuredChefs) {
              props.dispatch(setFeaturedChefs(resp.data.featuredChefs));
            }
          }
        })
        .catch(err => {
          console.error("FEATURED CHEFS: ", err);
        });

    return () => {
      window.removeEventListener('load', () => {
        window.scroll({top: props.isChef ? 0 : 550, left: 0, behavior: 'smooth' })
        setTimeout(() => {
          window.scrollTo(0,props.isChef ? 0 : 550);
        });
      });
    };
  }, []);

  const changeSearch = (type, placeholder) => {
    props.dispatch(setInitHomeList(type));
    setSearchType(type);
    setPlaceholder(placeholder);
    setInitialLoad(false);
    setTimeout(() => {
      window.scrollTo(0, 550);
      window.scroll({top: 550, left: 0, behavior: 'smooth' })
    });
  }

  const handleLogout = () => {
    props.dispatch(logoutUser());
    props.history.push("/");
  }

  const handleChefClick = () => {
    changeSearch('chef', 'Search chefs');
  };

  const handleDinerClick = () => {
    changeSearch('dish', 'Search dishes');
  };

  const { isChef } = props;

  const mobileView = <Hidden smUp>
    <Grid container alignItems="center" justify="center" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <img
        src="/images/logo.webp"
        alt="Cuisine Crafters"
        style={style.logo}
      />

      <p style={{
        paddingLeft: 15,
        paddingRight: 15,
        marginTop: 50,
        marginBottom: 20,
        fontSize: 20,
        textAlign: 'center',
        fontWeight: 500,
      }}>
        Thank you for signing in {props.diner ? props.diner.firstName : 'User'}! <br /><br />In order to use this service from your phone, please download the mobile app.
       </p>

      {/*<Box className="app-icons way-mbl-icon" style={{marginTop: 30}}>
        <Link to="/home">
          <img src="/images/appStore.webp" alt="App Store" style={style.storeImage} />
        </Link>
        <Link to="/home">
          <img src="/images/playStore.webp" alt="Play Store" style={style.storeImage} />
        </Link>
      </Box>*/}

      <p style={{
        paddingLeft: 15,
        paddingRight: 15,
        marginTop: 30,
        marginBottom: 20,
        fontSize: 20,
        textAlign: 'center',
        fontWeight: 500,
      }}>
        To use the service from a web browser, please sign in to <a href="https://cuisinecrafters.net" style={{
        color: "#ff8000"
      }}>cuisinecrafters.net</a> from a tablet, laptop or desktop computer.
      </p>

      <Grid item xs={12} style={{textAlign: 'center'}}>
        <button type="button" style={{
          backgroundColor: "#ff8000",
          border: 'none',
          color: "#fff",
          fontSize: 20,
          textAlign: "center",
          width: "70%",
          height: 40,
          borderRadius: 40,
          marginTop: 40,
          boxShadow: 'none',
          lineHeight: '40px',
        }}
                onClick={() => handleLogout()}
        >
          Logout
        </button>
      </Grid>

      <Grid item xs={12} style={{ marginTop: 50 }}>
        <Typography component="p" style={{
          textAlign: "center",
          fontSize: 16,
          color: "#ff8000"
        }}>&copy; Copyright {new Date().getFullYear()}. Cuisine Crafters</Typography>
      </Grid>

    </Grid>
  </Hidden>

  if (isChef) {
    return (
      <>
        <Hidden xsDown>
          <Portfolio history={props.history} />
        </Hidden>

        {mobileView}
      </>
    );
  }

  return (
    <>
      {mobileView}
    <div style={{ display: 'flex', width: '100%', height: '100%' }}>
      <Hidden xsDown>
        <Grid container>
          <Grid item xs={12}>
            <Header history={props.history} />
          </Grid>

          <Grid item xs={12} id="featured-section" style={{ height: '100% !important' }}>
            <DinerBanner chefClick={handleChefClick} dinerClick={handleDinerClick} />
          </Grid>

          {!initialLoad && <Grid item xs={12} style={{marginLeft: 30, marginRight: 30}} id="featured-section">
            {searchType === 'chef' && <FeaturedChefs history={props.history}/>}
            {searchType === 'dish' && <FeaturedDishes history={props.history}/>}
            {searchType === 'post' && <FeaturedPosts history={props.history}/>}
          </Grid>}

          <Footer />
        </Grid>
      </Hidden>

      <Hidden smUp>
        <Grid item xs={12}>
          <Header history={props.history} />
        </Grid>
      </Hidden>
    </div>
  </>
  );
});

const mapStatetoProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    diner: state.user.diner,
    becomeChef: state.auth.becomeChef,
    featuredChefs: state.chefs.featuredChefs,
    featuredDishes: state.chefs.featuredDishes,
    forceChangePassword: state.auth.forceChangePassword,
  };
};

const HomePage = connect(mapStatetoProps)(Home);

export default HomePage;
